import { getLeadSources } from 'clients/CustomerClient';
import { HTTP_STATUS } from 'constants/Enums';
import { useEffect, useState } from 'react';

// Fetch the active lead sources ("How did you find us?") for the sign-up form.
// Any failure (error, non-OK, empty list) resolves to an empty list so the caller can hide the field
// and never block registration.
const useLeadSources = () => {
  const [leadSources, setLeadSources] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let isMounted = true;

    const fetchLeadSources = async () => {
      try {
        const res = await getLeadSources();
        if (!isMounted) return;
        if (res?.status !== HTTP_STATUS.Ok || !Array.isArray(res?.data)) {
          setLeadSources([]);
          return;
        }
        setLeadSources(res.data.filter((item) => item?.value));
      } catch (error) {
        if (isMounted) setLeadSources([]);
      } finally {
        if (isMounted) setLoading(false);
      }
    };

    fetchLeadSources();

    return () => {
      isMounted = false;
    };
  }, []);

  return { leadSources, loading };
};

export default useLeadSources;
